var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "searchIcon",
    width: 29,
    height: 31,
    viewBox: "0 0 29 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "searchIcon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7807 11.8904C23.7807 18.4572 18.4572 23.7807 11.8904 23.7807C5.3235 23.7807 0 18.4572 0 11.8904C0 5.3235 5.3235 0 11.8904 0C18.4572 0 23.7807 5.3235 23.7807 11.8904ZM11.8904 19.457C16.0693 19.457 19.457 16.0693 19.457 11.8904C19.457 7.71145 16.0693 4.32377 11.8904 4.32377C7.71145 4.32377 4.32377 7.71145 4.32377 11.8904C4.32377 16.0693 7.71145 19.457 11.8904 19.457Z",
    fill: "#5C426C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "searchIcon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9427 30.2664L17.2952 21.6189L20.3525 18.5615L29.0001 27.2091L25.9427 30.2664Z",
    fill: "#5C426C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c2396c1c744fece71e002ea1898fff77.svg";
export { ForwardRef as ReactComponent };